import $ from 'jquery';

const channelPackAccordion = () => {

    const $packList = $('.js-channel-pack-list');

    if ($packList.length < 1) {
        return;
    }

    const itemSelector = '.js-pack-item';
    const btnSelector = '.js-pack-btn';
    const contentSelector = '.js-pack-content';
    const activeClass = 'active';

    $packList.on('click', btnSelector, function () {
        const $this = $(this);
        const $itemWrap = $this.closest(itemSelector);
        const $content = $itemWrap.find(contentSelector);
        $content.slideToggle();
        $itemWrap.toggleClass(activeClass);
    });

};

export default channelPackAccordion;
